import React, { useState } from "react";
import "./SlidersComp.scss";
const VerticalTabs = () => {
  const [activeSlide, setActiveSlide] = useState(1);

  return (
    <div className="VerticalTabsMain">
      <div className="VerticalTabs-l">
        <h1>
          Our
          <span>Strategies</span>
        </h1>

        <p>
          Cognier Technology Group embodies unparalleled strategies that act as
          a blueprint for securing steady yields{" "}
        </p>

        <svg
          width="339"
          height="382"
          viewBox="0 0 339 382"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M147.318 331.434C149.141 335.611 153.323 338.165 157.342 340.621C161.069 342.897 164.657 345.089 166.095 348.41C168.872 354.789 166.717 362.917 157.629 366.379L117.821 381.528C110.83 384.192 101.198 375.149 96.9456 365.387M147.318 331.434C146.478 329.508 145.179 326.557 143.645 323.07C138.796 312.049 131.596 295.683 129.103 289.507M147.318 331.434L146.859 331.634C146.021 329.712 144.724 326.765 143.192 323.282C138.343 312.26 131.136 295.878 128.639 289.695M147.318 331.434L146.859 331.634C148.69 335.827 152.786 338.419 156.642 340.779C156.787 340.867 156.931 340.955 157.075 341.043C158.872 342.141 160.605 343.2 162.084 344.37C163.678 345.63 164.935 346.99 165.637 348.609L165.637 348.61C166.976 351.686 167.121 355.172 165.848 358.3C164.578 361.42 161.879 364.225 157.451 365.912L117.643 381.06L117.643 381.06C114.408 382.293 110.447 380.846 106.675 377.732C102.927 374.638 99.5017 370.003 97.4041 365.188L96.9456 365.387M129.103 289.507C124.637 278.462 134.132 269.458 147.939 268.038M129.103 289.507L128.639 289.694C128.639 289.695 128.639 289.695 128.639 289.695M129.103 289.507L128.639 289.695M147.939 268.038C204.012 262.164 233.187 280.228 254.328 293.318C269.018 302.414 279.83 309.108 293.094 303.703M147.939 268.038L147.888 267.541C147.888 267.541 147.887 267.541 147.887 267.541M147.939 268.038L147.887 267.541M293.094 303.703C318.085 293.494 312.998 220.881 282.258 149.26C251.499 77.5805 202.02 23.0528 176.989 33.2232M293.094 303.703L292.905 303.24C292.905 303.24 292.905 303.24 292.904 303.24M293.094 303.703L292.904 303.24M176.989 33.2232C163.773 38.6103 161.223 50.355 157.709 66.5367C149.922 102.401 137.402 160.06 -6.45886 218.606M176.989 33.2232L177.178 33.6865C177.178 33.6864 177.178 33.6863 177.178 33.6862M176.989 33.2232L177.178 33.6862M-6.45886 218.606C-24.4988 225.976 -29.0622 255.321 -21.5083 272.9M-6.45886 218.606L-6.27039 219.069M-6.45886 218.606L-6.26975 219.069C-6.26996 219.069 -6.27018 219.069 -6.27039 219.069M-21.5083 272.9C-13.9739 290.441 10.6878 307.923 28.7278 300.592M-21.5083 272.9L-21.0489 272.703C-17.3294 281.362 -9.35945 290.043 -0.0716057 295.645C9.22321 301.251 19.7249 303.71 28.5379 300.129M-21.5083 272.9L-21.0489 272.703C-24.7778 264.025 -25.5253 252.405 -23.0945 242.039C-20.6621 231.665 -15.0802 222.668 -6.27039 219.069M28.7278 300.592C31.8542 299.308 43.3112 295.613 43.3112 295.613M28.7278 300.592L28.5395 300.129C28.539 300.129 28.5384 300.129 28.5379 300.129M28.7278 300.592L28.5379 300.129M43.3112 295.613C50.3904 305.141 57.6516 306.325 63.5517 307.287C68.3818 308.075 72.2997 308.714 74.4587 313.66L96.9456 365.387M43.3112 295.613L43.1577 295.138L43.4988 295.028L43.7125 295.315C46.8899 299.591 50.0897 302.147 53.1666 303.755C56.2472 305.365 59.2288 306.038 62.0001 306.521C62.5406 306.616 63.0763 306.703 63.6051 306.789C65.7585 307.14 67.7958 307.472 69.5642 308.177C71.8167 309.075 73.6615 310.584 74.917 313.46L74.9173 313.46L97.404 365.187L96.9456 365.387M43.3112 295.613C43.1577 295.138 43.1577 295.138 43.1576 295.138L43.1572 295.138L43.1556 295.138L43.1493 295.14L43.1246 295.148L43.028 295.179L42.6586 295.299C42.528 295.341 42.374 295.391 42.1991 295.448C41.946 295.53 41.6494 295.627 41.3171 295.735C40.1935 296.102 38.6627 296.604 37.0339 297.147C33.785 298.229 30.1204 299.48 28.5379 300.129M-6.27039 219.069C98.1829 176.56 133.55 134.474 148.073 100.749C153.56 88.0088 156.067 76.4598 158.205 66.6119C158.891 63.4512 159.54 60.4657 160.236 57.6722C163.108 46.1532 166.785 37.9228 177.178 33.6862M177.178 33.6862C183.229 31.228 190.843 32.6483 199.429 37.4204C208.003 42.1858 217.453 50.2456 227.105 60.8838C246.405 82.1565 266.437 113.659 281.798 149.457C297.151 185.226 306.091 221.23 308.076 249.546C309.069 263.707 308.321 275.917 305.784 285.204C303.244 294.504 298.942 300.774 292.904 303.24M292.904 303.24C284.985 306.468 277.958 305.305 270.336 301.838C266.516 300.099 262.557 297.787 258.268 295.161C257.072 294.429 255.849 293.672 254.598 292.897C251.37 290.898 247.947 288.779 244.273 286.649C223.839 274.8 195.533 262.549 147.887 267.541M147.887 267.541C140.899 268.26 134.948 270.902 131.302 274.823C127.636 278.766 126.33 283.983 128.639 289.695M271.744 265.936L271.748 265.934C272.222 265.74 272.625 265.343 272.968 264.834C273.314 264.319 273.627 263.651 273.906 262.851C274.465 261.251 274.914 259.056 275.217 256.341C275.824 250.907 275.856 243.317 274.966 234.071C273.187 215.575 267.718 190.405 255.745 162.52C243.782 134.635 228.663 111.77 215.834 96.1504C209.421 88.3417 203.572 82.3351 198.968 78.4152C196.668 76.4569 194.665 75.0075 193.048 74.1158C192.24 73.6704 191.512 73.3547 190.879 73.1887C190.256 73.0253 189.664 72.9905 189.172 73.1885L189.169 73.1896C188.682 73.3893 188.275 73.8231 187.93 74.3719C187.58 74.9297 187.259 75.6614 186.968 76.542C186.386 78.3049 185.902 80.734 185.555 83.7319C184.861 89.7323 184.712 98.0801 185.484 108.087C187.029 128.102 192.264 154.798 204.24 182.691C216.207 210.604 231.561 231.955 244.629 246.054C251.163 253.102 257.132 258.346 261.829 261.692C264.176 263.364 266.219 264.571 267.865 265.291C268.687 265.651 269.425 265.896 270.062 266.012C270.69 266.127 271.271 266.126 271.744 265.936Z"
            fill="#002133"
            stroke="url(#paint0_linear_5228_2392)"
          />
          <path
            d="M338 228C335.782 222.346 333.785 187.216 294.378 114.42C254.454 40.6662 205.657 6.98547 179.779 1.57688C170.295 -0.73828 149.662 2.68816 143 34.9153"
            stroke="url(#paint1_linear_5228_2392)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_5228_2392"
              x1="-25"
              y1="32"
              x2="82.2536"
              y2="441.402"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#219EBC" />
              <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_5228_2392"
              x1="143"
              y1="1"
              x2="219.131"
              y2="262.594"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#219EBC" />
              <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="VerticalTabs-r">
        <div
          onClick={() => {
            setActiveSlide(1);
          }}
          className={
            "VerticalTabs-Component " + (activeSlide === 1 ? " active " : "")
          }
        >
          <div className="VerticalTabs-Component-t">
            <svg
              width="101"
              height="100"
              viewBox="0 0 101 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50.6172" cy="50" r="49.5" stroke="#219EBC" />
              <path
                d="M66 50C66.0002 49.1312 65.9288 48.2638 65.7867 47.4067L60.6667 45.58L63 40.6667C61.9816 39.2563 60.7437 38.0184 59.3333 37L54.42 39.3334L52.5933 34.2134C50.8762 33.9289 49.1239 33.9289 47.4067 34.2134L45.58 39.3334L40.6667 37C39.2563 38.0184 38.0184 39.2563 37 40.6667L39.3334 45.58L34.2134 47.4067C33.9289 49.1239 33.9289 50.8761 34.2134 52.5933L39.3334 54.42L37 59.3333C38.0184 60.7437 39.2563 61.9816 40.6667 63L45.58 60.6666L47.4067 65.7866C49.1239 66.0711 50.8762 66.0711 52.5933 65.7866L54.42 60.6666L59.3333 63C60.7437 61.9816 61.9816 60.7437 63 59.3333L60.6667 54.42L65.7867 52.5933C65.9288 51.7362 66.0002 50.8688 66 50V50Z"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M50 55C52.7614 55 55 52.7614 55 50C55 47.2386 52.7614 45 50 45C47.2386 45 45 47.2386 45 50C45 52.7614 47.2386 55 50 55Z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>

            <h1>Crypto Collaboration</h1>
          </div>
          <div className="VerticalTabs-Component-b">
            <p>
              We allow crypto investors to directly transfer funds from their
              custodial wallets into our DigiTrust wallet. The funds imported
              can either be stored as cryptocurrencies or liquidated and
              reinvested into real estate portfolios and funds by purchasing
              tokens/shares of listed properties that are safeguarded against
              market fluctuations with a lock-in period. To maintain easy
              settlements the tokens purchased are burned as soon as the
              investment is withdrawn in order for new tokens to be minted for
              new investors to purchase.
            </p>
          </div>
        </div>{" "}
        <div
          onClick={() => {
            setActiveSlide(2);
          }}
          className={
            "VerticalTabs-Component " + (activeSlide === 2 ? " active " : "")
          }
        >
          <div className="VerticalTabs-Component-t">
            <svg
              width="101"
              height="100"
              viewBox="0 0 101 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50.6172" cy="50" r="49.5" stroke="#219EBC" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M52.8561 46.3902V34.1232C52.8561 32.8033 52.2544 32.6188 51.5122 33.7182L39.3514 51.7309C38.608 52.8321 39.083 53.7215 40.4097 53.7215H49.1439V65.9886C49.1439 67.3085 49.7456 67.493 50.4878 66.3936L62.6486 48.3808C63.392 47.2796 62.917 46.3902 61.5903 46.3902H52.8561Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>

            <h1>Invest Directly</h1>
          </div>
          <div className="VerticalTabs-Component-b">
            <p>
              We allow investors to pledge their tokens by directly investing
              their assets and in return receive fiat currencies converted by
              our partnered exchange platforms. This conversion of crypto tokens
              into fiat currencies helps in mitigating any risk of market price
              fluctuations. By partnering with exchange platforms we allow our
              users to invest directly in their listed properties and opt for
              the staking option. We provide our users with an expected return
              per annum report and the taxes report for their staked crypto.
              This helps them to manage funds stored in the wallet and generate
              returns from the same
            </p>
          </div>
        </div>{" "}
        <div
          onClick={() => {
            setActiveSlide(3);
          }}
          className={
            "VerticalTabs-Component " + (activeSlide === 3 ? " active " : "")
          }
        >
          <div className="VerticalTabs-Component-t">
            <svg
              width="101"
              height="100"
              viewBox="0 0 101 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50.6172" cy="50" r="49.5" stroke="#219EBC" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M48.2363 49.5015C48.4939 49.7795 48.6353 50.1426 48.6353 50.5182V61.5866C48.6353 62.2527 49.4458 62.5907 49.9255 62.1224L53.0388 58.5841C53.4554 58.0883 53.6851 57.8428 53.6851 57.352V50.5207C53.6851 50.1451 53.8291 49.782 54.0841 49.504L63.0172 39.8906C63.6863 39.1694 63.1713 38 62.1815 38H40.1389C39.1491 38 38.6315 39.1669 39.3031 39.8906L48.2363 49.5015Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>

            <h1>Managed Investment</h1>
          </div>
          <div className="VerticalTabs-Component-b">
            <p>
              By partnering with multiple exchange platforms such as ForumPay,
              we provide non-associated users with staking options for crypto
              tokens. In exchange for staking and sharing returns, the platform
              will settle payments to customers directly in the form of crypto
              or fiat. Our partnered exchange platform helps in converting the
              tokens into fiat currencies while we manage these funds on behalf
              of the users with a predefined return rate on the same.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerticalTabs;
